import Exec from "../Exec";
import { IDataType } from "src/engine/SourceCenter/Manager";
import IHttp from "src/lib/http/IHttp";
import Http from "src/lib/http/Http";
import PropsUtils from "src/engineEditor/props/utils/PropsUtils";
import GameConfig from "src/GameConfig";
import Utils from "src/lib/utils/Utils";
import Config from "src/engine/const/Config";
import IUIItem from "src/engine/interface/IUIItem";
import { Toast } from "antd-mobile";

interface IProps {
    uiItem: IUIItem;
    http: IHttp;
    useTimestamp?: boolean;
    notSetGameId?: boolean;
    errorToastMSG?: string;
    headersToArray?: boolean;
    // 是否可以同时多次触发SourceNet
    requestRepeat?: boolean;

    prefix?: string;
    dataSource?: any;
    postArgs?: string[];
}

/**
 *
 *
 * @class Handle
 */
class Handle extends Exec {
    /**
     * 初始化参数
     * @param data
     * @param props
     */
    init(data: any, props: IProps): IDataType {
        const { loading = false } = props.uiItem.props;

        return { loading };
    }

    handleHeaders(headers: any, props: IProps) {
        // const { http } = props;
        return headers;
    }

    private parserData(ret: any, data: IDataType) {
        return { data: ret };
    }

    propsListener() {
        return [...super.propsListener(), "http.url", "http.method", "initHeaders"];
    }

    propsUpdate() {
        this.mHandle.refresh();
    }

    mNetCount: number = 1;

    getHttp(props: IProps, headers: any) {
        return props.http;
    }

    handleDataRight(data: IDataType) {

    }

    exec(headers: any, data: IDataType, props: IProps): any {
        let http = this.getHttp(props, headers);
        const { useTimestamp, notSetGameId = false, postArgs = [], errorToastMSG, requestRepeat = false, prefix = "/cloudplt/api", dataSource } = props;
        const keyIndex = this.mNetCount + 1;


        this.mNetCount = keyIndex;
        http = { ...http, headers: { gameId: GameConfig.gameId, sname: GameConfig.server, ...headers } };

        if (http) {
            if (notSetGameId !== true) {
                //处理
                http.url = Utils.setUrlParams("sname", "[sname]", http.url);
                //处理
                http.url = Utils.setUrlParams("gameId", "[gameId]", http.url);
            }
            if (postArgs) {
                postArgs.map((arg: string) => {
                    http.url = Utils.setUrlParams(arg, `[${arg}]`, http.url);
                })
            }
            http.url = PropsUtils.handleUrl(http.url, { ...dataSource, ...http.headers }, true);
            http.url = http.url && (http.url.indexOf("http") === 0 || http.url.indexOf("//") === 0) ? http.url : Config.API + http.url;
            if (prefix) http.url = http.url.replace("/cloudplt/api", prefix);

            if (useTimestamp) http.url = Utils.setUrlParams("ts", new Date().valueOf(), http.url);
            //处理url
            // if (notSetGameId) {
            if (http.headers?.gameId) {
                delete http.headers.gameId;
            }
            if (http.headers?.sname) {
                delete http.headers.sname;
            }
            // }
            // 发送的 header 数据由 map 转成 list;
            if (props.headersToArray) http.headers = Utils.objectValues(http.headers);
            return new Promise((resolve, reject) => {
                Http.ajax(http).then(
                    (ret: any) => {
                        ret = ret || {};
                        ret.CODE = ret.CODE ?? 200;
                        if (keyIndex === this.mNetCount || requestRepeat) {
                            const retData = { ...data, ...this.parserData(ret, data), headers, loading: false };
                            resolve({ ...data, ...this.parserData(ret, data), headers, loading: false });
                            this.handleDataRight(retData);
                        }
                    },
                    (err: any) => {
                        err.data = err.data || {};
                        if (keyIndex === this.mNetCount || requestRepeat) {
                            resolve({
                                loading: false,
                                data: { CODE: (err && err.status) || 500, REV: false, MSG: (err && err.MSG) || (err && err.error) || "网络出现问题，请重试", ...err.data, headers },
                            });
                            if (errorToastMSG) Toast.show(errorToastMSG, 3, true);
                        }
                    }
                );
            });
        }
        return { ...data, data: { ...data.data, ...headers } };
    }
}

export default Handle;
